<script>	
	import sanitizeHtml from 'sanitize-html';
	import CardImage from './CardImage.svelte';

	import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

	export let id;
	export let iconName;
	export let text;
	export let flipped = false;
	export let cardWidth = 500;

	export let colours;

	const defaultColours = {
		dark: "black", 
		light: "grey", 
		underside: "rgb(215,215,215)"};

	// Define colours to use for card (if colours undefined, use default)
	const cardColours = colours ? colours : defaultColours;

	const sanitizeOptions = {
		allowedTags: [ 'b', 'i', 'em', 'strong', 'a' , 'br', 'p', 'span'],
		allowedAttributes: {
			'a': [ 'href', 'target' ],
			'span': [ 'class' ]
		}
	};

	function turn(node, {
		delay = 0,
		duration = 500
	}) {
		return {
			delay,
			duration,
			css: (t, u) => `
				transform: rotateY(${1 - (u * 180)}deg);
				-webkit-transform: rotateY(${1 - (u * 180)}deg);
			`
		};
	}


	export function flipCard () {
		flipped = !flipped

		if (flipped){
			dispatch('flipped', {
				id: id,
				iconName: iconName,
				flipped: flipped
			});
		}

	}
	
</script>

<div class="card-container" on:click={flipCard} style="width:{cardWidth}px; height:{cardWidth/3*4}px;
	--dark:{cardColours.dark}; 
	--light:{cardColours.light}; 
	--underside:{cardColours.underside}">
    <div class="card" class:forward="{!flipped}">
        {#if flipped}
        <div class="side back" transition:turn>
			<div class="contents">
				<h5><slot name="back"></slot></h5>
				<div class="body-text">{@html sanitizeHtml(text, sanitizeOptions)}</div>
			</div>
        </div>
        {:else}
        <div class="side front" transition:turn>
			<div class="contents">
				<div class="icon">
					<CardImage icon={iconName} colour={cardColours.dark}/>
				</div>
				<div class="title">
					<h4><slot name="front"></slot></h4>
				</div>
			</div>
        </div>
        {/if}
    </div>
</div>

<style>
	h4 {
		text-transform: uppercase;
		font-size: 1.5em;
		font-weight: 200;
		color: var(--dark);
		margin-top: 0;
	}

	h5 {
		text-align: left;
		font-size: 1.1em;
		font-weight: 600;
		color: black;
		margin-top: 0.5em;
		margin-bottom: 0.5em;
	}

	.body-text {
		text-align: left;
		color: rgb(45, 45, 45);
		font-size: 0.85em;
	}

	.icon {
		width: 100%;
	}

	.card-container {
		position: relative;
		flex-shrink: 0;
		margin-right: 20px;
		margin-bottom: 10px;
	}
	
	.card {
		width: 100%;
		height: 100%;
		position: absolute;
		perspective: 600;
	}

	/* Make sure that images don't flip back over... */
	.card.forward .icon {
		transform: rotateY(0deg);
		-webkit-transform: rotateY(0deg);
	}
	
	.side {
		position: absolute;
		height: 100%;
		width: 100%;
		overflow: hidden;
		transform-style: preserve-3d;
		-webkit-backface-visibility: hidden;
 		backface-visibility: hidden;
		border-radius: 16px;
		/* box-shadow: 0 0 0 1px var(--underside); */
		box-shadow: 5px 5px 5px 3px rgba(0,0,0,0.5);
	}

	.side.front {
		background-color: var(--light);
	}

	.side.back {
		background-color: var(--underside);
	}

	.contents {
		padding: 10% 10% 5% 10%; /* trbl */
		width: 80%;
		height: 85%;
	}

	.side.front > .contents {
		display: flex;
		justify-content: center;
		align-content: space-around;
		flex-direction: column;
	}
	
</style>

